module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0138.jpg?v=34939bbc";